import React from 'react';

const COLUMNS = ['Date', 'Type', 'Name', 'Email', 'Phone', 'Details'];

const leadDetails = (l) => l.message || l.address || l.property_address || l.interest || l.guide_type || '—';

const LeadRow = ({ lead }) => (
  <tr className="border-b border-gray-100 hover:bg-sand-50 align-top">
    <td className="px-4 py-3 whitespace-nowrap text-neutral-500">{(lead.created_at || '').slice(0, 10)}</td>
    <td className="px-4 py-3"><span className="text-xs font-bold uppercase tracking-wide text-gold-700 bg-gold-100 px-2 py-1 rounded-full whitespace-nowrap">{(lead.lead_type || '').replace(/_/g, ' ')}</span></td>
    <td className="px-4 py-3 font-semibold text-[#143160]">{lead.name || '—'}</td>
    <td className="px-4 py-3"><a className="text-blue-600 hover:underline" href={`mailto:${lead.email}`}>{lead.email}</a></td>
    <td className="px-4 py-3 whitespace-nowrap">{lead.phone || '—'}</td>
    <td className="px-4 py-3 text-neutral-600 max-w-xs">{leadDetails(lead)}</td>
  </tr>
);

export const LeadsTable = ({ leads }) => {
  if (leads.length === 0) return <p className="text-neutral-500">No leads yet.</p>;
  return (
    <div className="overflow-x-auto bg-white rounded-xl shadow border border-gray-100">
      <table className="w-full text-sm" data-testid="leads-table">
        <thead className="bg-[#143160] text-white text-left">
          <tr>{COLUMNS.map((c) => <th key={c} className="px-4 py-3">{c}</th>)}</tr>
        </thead>
        <tbody>{leads.map((l) => <LeadRow key={l.id} lead={l} />)}</tbody>
      </table>
    </div>
  );
};
